import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { cloneDeep } from "lodash-es";
import Component from 'vue-class-component';
import { DataStub, isNullish } from '@tencent/data-schema-core';
import { getVariableName, tryEval } from "../../lib/utils";
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../lib/utils/consts";
import { getPopupPosition } from "../../lib/utils/styling";
import UcWindow from "../UcWindow";
import WForm from "../../lib/builtin/components/Form";
import WFormItem from "../../lib/builtin/components/FormItem";
import WRadio from "../../lib/builtin/components/Radio/index";
import AnyInput from "../../lib/builtin/designerComponents/AnyInput";
import { highlightRect } from "../../lib/utils/browser/highlightRect";
import { findAndRemove } from "../../lib/utils/array";
import { generateDataSchemaFromValues } from "../../lib/utils/dataSchema/generateDataSchemaFromValues";
import { isExprObject } from '@tencent/data-schema-core/lib/utils/eval';
import ExprInput from './ExprInput';
import Checkbox from "../../lib/builtin/components/Checkbox/index";
import WButton from "../../lib/builtin/components/Button";
const stateTypeOptions = [{
  label: '普通变量',
  value: 'normal'
}, {
  label: 'Computed 变量',
  value: 'computed'
}];
const setterInputDataStub = new DataStub({
  schema: {
    type: 'object',
    fields: [{
      id: 'value',
      title: 'Setter 收到的值'
    }]
  }
});
const COMPONENT_NANE = 'UpsertStateVariableDialog';
const MAX_WINDOW_WIDTH = 1920;
let UpsertStateVariableDialog = class UpsertStateVariableDialog extends Vue {
  constructor() {
    super(...arguments);
    this.shown = false;
    this.left = '0px';
    this.top = '0px';
    this.width = '580px';
    this.oldId = ''; // 如果是在编辑现有的，则会有值
    this.newId = '';
    this.stateType = 'normal';
    this.stateDefaultValue = null;
    this.stateDefaultValueExpr = '';
    this.stateExampleValue = null;
    this.stateDataSchema = {};
    this.stateGetter = '';
    this.stateSetter = '';
    this.stateGetterUseCache = true;
    this.stateTitle = '';
    this.stateDescription = '';
    this.stateSyncLocalStorage = false;
    this.stateExampleValueEnabled = false;
    this.stateDefaultValueUseExpr = false;
    this.exprIsChanged = false;
    this.windowTitle = '';
  }
  renderPrimaryKeyTip() {
    var _this$stateDataSchema, _this$stateDataSchema2;
    const h = this.$createElement;
    if (this.stateType !== 'computed') return null;
    if (((_this$stateDataSchema = this.stateDataSchema) === null || _this$stateDataSchema === void 0 ? void 0 : _this$stateDataSchema.type) !== 'array') return null;
    const pk = (_this$stateDataSchema2 = this.stateDataSchema) === null || _this$stateDataSchema2 === void 0 || (_this$stateDataSchema2 = _this$stateDataSchema2.items) === null || _this$stateDataSchema2 === void 0 || (_this$stateDataSchema2 = _this$stateDataSchema2.fields) === null || _this$stateDataSchema2 === void 0 || (_this$stateDataSchema2 = _this$stateDataSchema2.find(field => field === null || field === void 0 ? void 0 : field.isPrimaryKey)) === null || _this$stateDataSchema2 === void 0 ? void 0 : _this$stateDataSchema2.id;
    if (!pk) return null;
    return h("div", {
      "class": "w-formItem-description",
      "style": {
        textAlign: 'right',
        marginBottom: '16px'
      }
    }, [" \u2757\uFE0F ", pk, " \u5B57\u6BB5\u5DF2\u88AB\u6307\u5B9A\u4E3A\u4E3B\u952E "]);
  }
  render() {
    const h = arguments[0];
    if (!this.shown) return null; // 解脱 computed 依赖
    return h("div", [h("uc-window", {
      "attrs": {
        "left": this.left,
        "top": this.top,
        "width": this.width,
        "maxWidth": MAX_WINDOW_WIDTH,
        "styleStorageId": COMPONENT_NANE,
        "title": this.windowTitle || `${this.oldId ? '编辑' : '创建'}页面变量(state)`,
        "visible": true,
        "autoShrinkHeight": true
      },
      "on": {
        "close": this.cancel
      }
    }, [h(WForm, {
      "attrs": {
        "isRoot": true,
        "layout": "horizontal",
        "labelWidth": "80px",
        "fillLine": true
      }
    }, [h(WFormItem, {
      "attrs": {
        "label": "变量名",
        "description": this.oldId && this.oldId !== this.newId ? '建议不要修改英文名！可能会破坏现有绑定逻辑！' : ''
      }
    }, [h("div", {
      "style": "display: flex"
    }, [h("div", {
      "style": "border:1px solid #eee; color: #999; border-right: 0; margin-right:-1px; display:flex; align-items: center; padding: 0 6px"
    }, ["state."]), h("input", {
      "attrs": {
        "type": "text",
        "spellcheck": "false"
      },
      "class": "uc-inputbox",
      "style": "flex-grow: 1;",
      "ref": "newId",
      "domProps": {
        "value": this.newId
      },
      "on": {
        "change": this.handleNewIdChange
      }
    }), h("input", _mergeJSXProps([{
      "on": {
        "input": $event => {
          if ($event.target.composing) return;
          this.stateTitle = $event.target.value;
        }
      },
      "attrs": {
        "type": "text",
        "spellcheck": "false",
        "placeholder": "中文名(可选)"
      },
      "class": "uc-inputbox",
      "style": "flex-grow: 1; margin-left: 16px;",
      "domProps": {
        "value": this.stateTitle
      }
    }, {
      directives: [{
        name: "model",
        value: this.stateTitle,
        modifiers: {}
      }]
    }]))])]), h(WFormItem, {
      "attrs": {
        "label": "变量类型"
      }
    }, [h(WRadio, {
      "attrs": {
        "options": stateTypeOptions
      },
      "model": {
        value: this.stateType,
        callback: $$v => {
          this.stateType = $$v;
        }
      }
    })]), this.stateType === 'computed' && [h(WFormItem, {
      "attrs": {
        "label": "Getter",
        "tooltipText": "可编写一段JS逻辑代码，每次读这个变量时，会由这里 return 的值决定内容",
        "required": true
      }
    }, [h(ExprInput, {
      "attrs": {
        "placeholder": '示例：\nreturn state.type === 1 ? \'谢谢你\' : \'加油\'',
        "multipleLine": true,
        "notifyVoidReturn": true
      },
      "model": {
        value: this.stateGetter,
        callback: $$v => {
          this.stateGetter = $$v;
        }
      }
    })]), h(WFormItem, {
      "attrs": {
        "label": "Setter",
        "tooltipText": '可选，在每次对这个变量赋值时将执行这里的JS逻辑代码。\n代码里可读取隐含的变量“value”，内容为 setter 收到的新值'
      }
    }, [h(ExprInput, {
      "attrs": {
        "placeholder": '特殊功能，不需要可留空。\n这里可通过隐含的变量“value”引用到 setter 收到的新值',
        "multipleLine": true,
        "dataStub": setterInputDataStub
      },
      "model": {
        value: this.stateSetter,
        callback: $$v => {
          this.stateSetter = $$v;
        }
      }
    })]), h(WFormItem, {
      "attrs": {
        "label": "缓存",
        "tooltipText": '建议开启，可优化页面性能，仅在依赖的变量发生更新时重新运行 Getter。如果遇到数据不及时更新，再考虑关闭'
      }
    }, [h(Checkbox, {
      "attrs": {
        "label": "开启 (推荐)"
      },
      "model": {
        value: this.stateGetterUseCache,
        callback: $$v => {
          this.stateGetterUseCache = $$v;
        }
      }
    })])], this.stateType === 'normal' && [h(WFormItem, {
      "attrs": {
        "label": "初始值",
        "required": true,
        "description": this.stateDefaultValueUseExpr ? '输入表达式，页面加载时会计算它，并将结果作为变量初始值' : '可以输入 JSON 或者 YAML 语法'
      }
    }, [h("div", {
      "style": "display: flex; align-items: flex-start; gap: 4px"
    }, [this.stateDefaultValueUseExpr ? h("div", {
      "style": "flex: 1;"
    }, [h(ExprInput, {
      "attrs": {
        "placeholder": '* 表达式前后，无需双花括号\n* 只能引用 非动态的普通变量、上下文变量，\n  其他可能出错',
        "multipleLine": true,
        "notifyVoidReturn": true
      },
      "model": {
        value: this.stateDefaultValueExpr,
        callback: $$v => {
          this.stateDefaultValueExpr = $$v;
        }
      }
    })]) : h(AnyInput, {
      "style": "height: 5em; flex: 1",
      "model": {
        value: this.stateDefaultValue,
        callback: $$v => {
          this.stateDefaultValue = $$v;
        }
      }
    }), h(Checkbox, {
      "attrs": {
        "label": "动态"
      },
      "model": {
        value: this.stateDefaultValueUseExpr,
        callback: $$v => {
          this.stateDefaultValueUseExpr = $$v;
        }
      }
    })])])], h(WFormItem, {
      "attrs": {
        "label": "示例值",
        "description": this.stateExampleValueEnabled ? '编一个假数据，以便在设计页面时看效果。支持 JSON 或者 YAML 语法' : '',
        "required": this.isExampleValueRequired
      }
    }, [h("div", {
      "slot": "label"
    }, [h(Checkbox, {
      "attrs": {
        "label": "示例值",
        "readonly": this.isExampleValueRequired
      },
      "model": {
        value: this.stateExampleValueEnabled,
        callback: $$v => {
          this.stateExampleValueEnabled = $$v;
        }
      }
    })]), this.stateExampleValueEnabled ? h("div", {
      "style": "display: flex; align-items: flex-start; gap: 4px"
    }, [h(AnyInput, {
      "style": "height: 5em; flex: 1",
      "model": {
        value: this.stateExampleValue,
        callback: $$v => {
          this.stateExampleValue = $$v;
        }
      }
    }), this.computeExampleValueFromExpr && h(WButton, {
      "on": {
        "click": this.computeExampleValueFromExpr
      },
      "attrs": {
        "type": this.exprIsChanged ? 'primary' : 'normal'
      }
    }, ["\u4ECE\u8868\u8FBE\u5F0F\u8BA1\u7B97"])]) : h("div", {
      "style": "opacity:.7"
    }, ["\u7F16\u4E00\u4E2A\u5047\u6570\u636E\uFF0C\u4EE5\u4FBF\u5728\u8BBE\u8BA1\u9875\u9762\u65F6\u770B\u6548\u679C\u3002", h("a", {
      "attrs": {
        "href": "javascript:void(0)"
      },
      "on": {
        "click": e => {
          e.preventDefault();
          this.stateExampleValueEnabled = true;
        }
      }
    }, ["\u914D\u7F6E \xBB"])])]), this.stateType === 'normal' && [h(WFormItem, {
      "attrs": {
        "labelWidth": "12",
        "description": '同一用户使用此页面时,变量的值将被保存,并作为下一次打开此页面的初始值'
      }
    }, [h("div", [h(Checkbox, {
      "attrs": {
        "label": "同步本地缓存"
      },
      "model": {
        value: this.stateSyncLocalStorage,
        callback: $$v => {
          this.stateSyncLocalStorage = $$v;
        }
      }
    })])])], this.renderPrimaryKeyTip(), h("div", {
      "style": "display: flex;position: sticky;bottom: -16px;gap: 4px;z-index: 10;background: #fff; border-top: 1px solid #eee;padding-top: 16px;"
    }, [h("div", {
      "style": "flex: 1"
    }), this.oldId && h("button", {
      "class": "uc-button",
      "on": {
        "click": this.handleDelete
      },
      "attrs": {
        "type": "button"
      }
    }, [h("i", {
      "class": "fa fa-trash"
    }), ' 删除']), ' ', h("button", {
      "class": "uc-button isPrimary",
      "on": {
        "click": this.handleSubmit
      },
      "attrs": {
        "type": "button"
      }
    }, [this.oldId ? '更新' : '创建', "\u9875\u9762\u53D8\u91CF"])])])])]);
  }
  get isExampleValueRequired() {
    return this.stateType === 'computed' || this.stateType === 'normal' && this.stateDefaultValueUseExpr;
  }
  get computeExampleValueFromExpr() {
    if (this.stateType === 'computed') {
      return () => {
        const val = tryEval(this.stateGetter, this.renderer);
        this.stateExampleValue = cloneDeep(val);
        this.exprIsChanged = false;
      };
    }
    if (this.stateType === 'normal') {
      if (this.stateDefaultValueUseExpr) return () => {
        const val = tryEval(this.stateDefaultValueExpr, this.renderer);
        this.stateExampleValue = cloneDeep(val);
        this.exprIsChanged = false;
      };
    }
    return null;
  }
  created() {
    this.$watch(() => this.isExampleValueRequired, required => {
      const current = this.stateExampleValueEnabled;
      if (required && !current) this.stateExampleValueEnabled = true;
      if (!required && current && isNullish(this.stateExampleValue)) this.stateExampleValueEnabled = false;
    });
    // 如果发生了任何的变化，需要提醒用户“从表达式重新生成示例值”
    this.$watch(() => this.computeExampleValueFromExpr && [this.stateType, this.stateGetter, this.stateDefaultValueExpr, this.stateDefaultValueUseExpr], () => {
      this.exprIsChanged = true;
    });
  }
  dumpToStateSchema() {
    const {
      newId,
      stateType,
      stateGetter,
      stateSetter,
      stateGetterUseCache,
      stateDefaultValue,
      stateExampleValue,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      stateDataSchema,
      stateTitle,
      stateDescription,
      stateSyncLocalStorage,
      stateExampleValueEnabled,
      stateDefaultValueUseExpr,
      stateDefaultValueExpr
    } = this;
    let answer = {};
    // TODO: 以后再放开完全手写 Schema 的能力，这个坑有点大
    // cloneDeep(stateDataSchema) || {};
    answer['uc:stateType'] = stateType;
    if (stateType === 'computed') {
      if (stateGetter) answer['uc:stateGetter'] = stateGetter;
      if (stateSetter) answer['uc:stateSetter'] = stateSetter;
      if (!stateGetter && !stateSetter) throw new Error('Computed 变量至少需要配置 Getter 或者 Setter');
      answer['uc:stateGetterUseCache'] = !!stateGetterUseCache;
    }
    if (stateType === 'normal') {
      answer['uc:syncLocalStorage'] = stateSyncLocalStorage;
      if (stateDefaultValueUseExpr) {
        if (!stateDefaultValueExpr) throw new Error('变量初始值使用了“动态”模式，请输入一个表达式');
        answer.default = {
          $expr: stateDefaultValueExpr
        };
      } else {
        if (typeof stateDefaultValue === 'undefined') throw new Error('请提供一个变量初始值');
        answer.default = cloneDeep(stateDefaultValue);
      }
    }
    if (this.isExampleValueRequired && (!stateExampleValueEnabled || isNullish(stateExampleValue))) {
      throw new Error('Computed 变量模式，或者初始值为 动态 的情况下，必须提供一个 示例值');
    }
    if (stateExampleValueEnabled && !isNullish(stateExampleValue)) {
      answer.example = cloneDeep(stateExampleValue);
    }
    if (!newId) throw new Error('请为变量提供一个ID');
    answer.id = newId;
    if (stateTitle) answer.title = stateTitle;
    if (stateDescription) answer.description = stateDescription;
    // 最后补全数据结构
    if (!answer.type) {
      const valueSchema = generateDataSchemaFromValues(answer.example, isExprObject(answer.default) ? tryEval(answer.default.$expr, this.renderer) : answer.default);
      answer = {
        ...valueSchema,
        ...answer
      };
    }
    return answer;
  }
  loadFromStateSchema(schema) {
    const {
      'uc:stateType': stateType = 'normal',
      'uc:stateGetter': stateGetter = '',
      'uc:stateSetter': stateSetter = '',
      'uc:stateGetterUseCache': stateGetterUseCache = false,
      'uc:syncLocalStorage': stateSyncLocalStorage = false,
      default: stateDefaultValue = void 0,
      example: stateExampleValue = void 0,
      title: stateTitle = '',
      description: stateDescription = '',
      ...stateDataSchema
    } = schema;
    this.stateType = stateType;
    this.stateGetter = stateGetter;
    this.stateSetter = stateSetter;
    this.stateGetterUseCache = stateGetterUseCache;
    this.stateExampleValue = stateExampleValue;
    this.stateTitle = stateTitle;
    this.stateDescription = stateDescription;
    this.stateDataSchema = !stateDataSchema.type ? {} : cloneDeep(stateDataSchema);
    this.stateSyncLocalStorage = stateSyncLocalStorage;
    this.stateExampleValueEnabled = !isNullish(stateExampleValue);
    if (isExprObject(stateDefaultValue)) {
      this.stateDefaultValueUseExpr = true;
      this.stateDefaultValue = void 0;
      this.stateDefaultValueExpr = stateDefaultValue.$expr;
    } else {
      this.stateDefaultValueUseExpr = false;
      this.stateDefaultValue = cloneDeep(stateDefaultValue);
      this.stateDefaultValueExpr = '';
    }
    // 重置一些编辑器的样式
    this.$nextTick(() => {
      // exprIsChanged 是在 watch 里更新的，所以要在 nextTick 改回 false
      this.exprIsChanged = false;
    });
  }
  /**
   * 无论最后是提交还是取消，都使用这个方法
   */
  hideModal(ans) {
    if (!this.shown) return;
    if (this.resolveFn) {
      this.resolveFn(ans);
      this.resolveFn = undefined;
    }
    this.shown = false;
    this.loadFromStateSchema({}); // reset
  }
  cancel() {
    this.hideModal(null);
  }
  handleNewIdChange(e) {
    const target = e.target;
    const rawValue = target.value;
    this.newId = getVariableName(rawValue, this.existingIds);
    // 如果输入有问题，比如有无效字符，那么 getVariableName 会做清理。
    if (this.newId !== rawValue) {
      this.$nextTick(() => {
        highlightRect(target.getBoundingClientRect());
        target.value = this.newId; // 以防万一，DOM 不更新（确实发生过）
      });
    }
  }
  handleSubmit() {
    this.$nextTick(() => {
      try {
        const dataSchema = this.dumpToStateSchema();
        this.designer.updateStateVariable(dataSchema, this.newId === this.oldId ? '' : this.oldId);
        this.hideModal({
          id: dataSchema.id,
          dataSchema,
          defaultValue: dataSchema.default,
          dataPath: `state.${dataSchema.id}`
        });
      } catch (err) {
        console.log(err);
        this.designer.uc.$alert(`保存变量失败。${err}`);
      }
    });
  }
  handleDelete() {
    this.designer.updateStateVariable(null, this.oldId);
    this.cancel();
  }
  show(opt) {
    return new Promise(resolve => {
      var _opt$isEditingExistin, _renderer$ucPagelet$s;
      const {
        renderer
      } = this.designer;
      if (!renderer) return;
      const position = getPopupPosition({
        anchor: opt.place || document.activeElement,
        container: this.designer.$el,
        width: parseInt(this.width, 10),
        height: 400
      });
      this.left = `${position.x}px`;
      this.top = `${position.y}px`;
      this.shown = true;
      this.resolveFn = resolve;
      this.windowTitle = opt.windowTitle || '';
      this.renderer = renderer;
      this.oldId = (_opt$isEditingExistin = opt.isEditingExisting) === null || _opt$isEditingExistin === void 0 ? void 0 : _opt$isEditingExistin.id;
      this.existingIds = ((_renderer$ucPagelet$s = renderer.ucPagelet.stateSchema) === null || _renderer$ucPagelet$s === void 0 || (_renderer$ucPagelet$s = _renderer$ucPagelet$s.fields) === null || _renderer$ucPagelet$s === void 0 ? void 0 : _renderer$ucPagelet$s.map(x => x.id)) || [];
      if (this.oldId) findAndRemove(this.existingIds, x => x === this.oldId);
      this.newId = getVariableName(opt.id, this.existingIds);
      this.loadFromStateSchema({
        ...(opt.isEditingExisting || {
          // 新变量的默认配置...
          'uc:stateGetterUseCache': true
        }),
        ...opt.schema,
        id: opt.id
      });
      this.$nextTick(() => {
        const inputBox = this.$refs[this.oldId ? 'defaultValueInput' : 'newId'];
        if (!inputBox) return;
        inputBox.focus();
        if ('select' in inputBox) inputBox.select();
      });
    });
  }
};
UpsertStateVariableDialog = __decorate([Component({
  name: 'UpsertStateVariableDialog',
  components: {
    UcWindow
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  }
})], UpsertStateVariableDialog);
export default UpsertStateVariableDialog;
//# sourceMappingURL=UpsertStateVariableDialog.js.map
